import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Rightpart.css";
import profile from "../assets/images/profile.png";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import axios from "../../api/axios";

export default function PurchaseRight() {
  const [user, setUser] = useState(null);
  const [orders, setOrders] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) {
      setUser(JSON.parse(userData));
    }

    axios.get("/purchase-history")
      .then(response => {
        if (response.data && response.data.data) {
          setOrders(response.data.data);
        }
      })
      .catch(error => {
        console.error("Error fetching purchase history:", error);
      });
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user");
    localStorage.removeItem("wishlist_slugs");
    window.dispatchEvent(new Event("user-profile-updated"));
    window.dispatchEvent(new Event("wishlist-slugs-updated"));
    axios.get("/auth/logout").catch(() => {});
    navigate("/login");
  };

  return (
    <div className="outer-div-right">
      <div className="dashbord-right-section">
        <div className="dashbord-header">
          <p className="title-dash">Purchase History</p>
          <div className="dropdown-section d-flex align-items-center">
            <div className="dropdown">
              <button
                className="btn dropdown-toggle d-flex align-items-center gap-3"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div className="profile-name">
                  <img src={user?.avatar_original || user?.avatar || profile} alt="Profile" style={{ width: '40px', height: '40px', borderRadius: '50%' }} />
                  <div className="name-mail">
                    <h4>{user?.name || "User"}</h4>
                    <p>{user?.email || user?.phone || "Email/Phone"}</p>
                  </div>
                </div>
                <ExpandMoreIcon />
              </button>

              <ul className="dropdown-menu ">
                <li><Link to="/profile" className="dropdown-item">Profile</Link></li>
                <li><Link to="/support" className="dropdown-item">Support</Link></li>
                <li><button onClick={handleLogout} className="dropdown-item w-100 text-start border-0 bg-transparent">Logout</button></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="content-dashborad-outer">
          
          <div className="table-dashbord table-responsive">
            <table>
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th>Order Status</th>
                  <th>Date</th>
                  <th>Number of Product</th>
                  <th>Amount</th>
                  <th>View</th>
                </tr>
              </thead>

              <tbody>
                {orders.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center">No orders found.</td>
                  </tr>
                ) : (
                  orders.map((order) => (
                    <tr key={order.id}>
                      <td>#{order.code}</td>
                      <td>
                        <span className={`status ${order.delivery_status}`}>
                          {order.delivery_status_string}
                        </span>
                      </td>
                      <td>{order.date}</td>
                      <td>{order.number_of_products || 0}</td>
                      <td>{order.grand_total}</td>
                      <td>
                        <Link to={`/orderdetail?id=${order.id}`} style={{ color: 'inherit' }}>
                          <VisibilityOutlinedIcon />
                        </Link>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
